// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1X3X_","content":"RecentSearches_content__10T_u"};